import types from "../types"

/* Create */
function create(model, id, data, callback) {
  return {
    type: types.create,
    model,
    id,
    data,
    callback,
  }
}

create.success = function createSuccess(model, id, createdId) {
  return {
    type: types.createSuccess,
    model,
    id,
    createdId,
  }
}

create.error = function createError(model, id, error) {
  return {
    type: types.createError,
    model,
    id,
    error,
  }
}

create.cancel = function createCancel(model, id, reason = `No reason`) {
  return {
    type: types.createError,
    model,
    id,
    reason,
  }
}

export default create
